<!-- ════════════ NAVBAR ════════════ -->
<nav class="unav">
  <div class="container-fluid">
    <a class="unav-brand" routerLink="/">
      <img src="assetses/img/logo.png" alt="UMYOBizDFW">
      <span>UMYO<em>BizDFW</em></span>
    </a>
    <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
    <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
      <li><a href="/">Home</a></li>
      <li><a href="/about">About Us</a></li>
      <li><a routerLink="/networks">Network</a></li>
      <li><a routerLink="/hub">Hub</a></li>
      <li><a routerLink="/anti-bullying" class="active">Anti-Bullying</a></li>
      <li><a routerLink="/community-impact">Community Fund</a></li>
      <li><a routerLink="/empower-youth">Empower Youth</a></li>
      <li><a routerLink="/services">Type of Servcies</a></li>
      <li><a routerLink="/cf">Card Features</a></li>
    </ul>
    <!-- <a href="/#registration-form" class="unav-cta" >Join $2.54/mo</a> -->
  </div>
</nav>

<!-- ════════ HERO ════════ -->
<section class="uhero">
  <div class="cg"></div>
  <div class="orb orb1"></div>
  <div class="orb orb2"></div>
  <div class="container" style="position:relative;z-index:1;">
    <div class="row align-items-center gy-5">
      <div class="col-lg-7">
        <p class="hero-ey">UMYOBizDFW Presents</p>
        <h1 class="hero-t">
          DFW Anti-Bullying<br><span class="ac">Movement</span>
        </h1>
        <p class="hero-sub">Students First. Community First. Security First. A structured, measurable initiative backed by UFC fighters and Dallas Security Academy — delivering real change across Dallas–Fort Worth.</p>
        <div class="hero-btns">
          <a href="/#partner" class="btn-c">Support a Student</a>
          <a href="/#partner" class="btn-o">Register Your School</a>
        </div>
      </div>
      <div class="col-lg-5 d-none d-lg-flex justify-content-center">
        <div class="hero-visual">
          <div class="fist-ring">
            <span class="fist-badge">UFC Backed</span>
            <span class="fist-badge">DSA Certified</span>
            <span class="fist-badge">DFW Wide</span>
            <div class="fist-inner">🥊</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="scr">
    <div class="scl"></div>
    <span>Scroll</span>
  </div>
</section>

<!-- ════════ MISSION STRIP ════════ -->
<div class="umstrip">
  <div class="container">
    <div class="ums"><span class="ums-n">DFW</span><br><span class="ums-l">Coverage Area</span></div>
    <div class="ums-d"></div>
    <div class="ums"><span class="ums-n">UFC</span><br><span class="ums-l">Fighter Backed</span></div>
    <div class="ums-d"></div>
    <div class="ums"><span class="ums-n">100K+</span><br><span class="ums-l">Platform Reach</span></div>
    <div class="ums-d"></div>
    <div class="ums"><span class="ums-n">6</span><br><span class="ums-l">Student Programs</span></div>
    <div class="ums-d"></div>
    <div class="ums"><span class="ums-n">20%</span><br><span class="ums-l">Revenue to Associations</span></div>
  </div>
</div>

<!-- ════════ ABOUT THE MOVEMENT ════════ -->
<section class="uabout" id="about">
  <div class="container">
    <div class="row align-items-center g-5">
      <div class="col-lg-6">
        <p class="lbl " sipScrollReveal [sipDelay]="0">The Movement</p>
        <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">Bullying Is Not Just<br>a School Issue.<br><span class="ac">It's a Community Crisis.</span></h2>
        <div class="dv " sipScrollReveal [sipDelay]="0.16"></div>
        <p class="tx " sipScrollReveal [sipDelay]="0.24">Bullying impacts <strong style="color:var(--cw);">academic performance, mental health, family stability, and long-term confidence</strong>. When left unaddressed, it creates cycles of trauma that follow students — and families — far beyond school years.</p>
        <p class="tx " sipScrollReveal [sipDelay]="0.32" style="margin-top:1rem;">The DFW Anti-Bullying Movement exists to break that cycle. Not with hashtags. Not with awareness campaigns that disappear after a week. But with <strong style="color:var(--cw);">structured, professional, measurable intervention</strong> — delivered by certified trainers and backed by real athletes who've overcome adversity themselves.</p>
        <div class="quote-line " sipScrollReveal [sipDelay]="0.4" style="margin-top:2rem;">
          <p>"No student should face adversity alone. No family should feel like the community has turned its back on them. That ends here — in DFW."</p>
        </div>
      </div>
      <div class="col-lg-6 " sipScrollReveal [sipDelay]="0.48" style="transition-delay:.15s;">
        <div class="row g-3 text-center">
          <div class="col-6">
            <div class="uc p-4">
              <div class="impact-num">3M+</div>
              <p style="font-size:.78rem;color:var(--cm);text-transform:uppercase;letter-spacing:.1em;margin:.4rem 0 0;font-family:var(--fb);">Students Affected by Bullying Nationally</p>
            </div>
          </div>
          <div class="col-6">
            <div class="uc p-4">
              <div class="impact-num">77%</div>
              <p style="font-size:.78rem;color:var(--cm);text-transform:uppercase;letter-spacing:.1em;margin:.4rem 0 0;font-family:var(--fb);">Students Report Being Bullied at School</p>
            </div>
          </div>
          <div class="col-6">
            <div class="uc p-4">
              <div class="impact-num">30%</div>
              <p style="font-size:.78rem;color:var(--cm);text-transform:uppercase;letter-spacing:.1em;margin:.4rem 0 0;font-family:var(--fb);">Academic Decline Linked to Bullying</p>
            </div>
          </div>
          <div class="col-6">
            <div class="uc p-4">
              <div class="impact-num">0</div>
              <p style="font-size:.78rem;color:var(--cm);text-transform:uppercase;letter-spacing:.1em;margin:.4rem 0 0;font-family:var(--fb);">Tolerance for Bullying in Our Ecosystem</p>
            </div>
          </div>
        </div>
        <div class=" mt-3" sipScrollReveal [sipDelay]="0.56" style="background:rgba(0,212,255,.05);border:1px solid rgba(0,212,255,.12);border-radius:12px;padding:1.5rem;text-align:center;">
          <p style="font-size:.9rem;color:var(--cm);margin:0;font-style:italic;">
            Sponsored by <strong style="color:var(--cw);">Dallas Security Academy</strong> and supported by professional MMA fighters — this is mentorship backed by professionals, not volunteers.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════ UFC FIGHTER SECTION ════════ -->
<section class="ufighter">
  <div class="container">
    <div class="text-center mb-5">
      <p class="lbl " sipScrollReveal [sipDelay]="0">Our Champion Supporters</p>
      <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">Backed by Those Who<br><span class="ac">Overcame the Odds</span></h2>
      <div class="dv " sipScrollReveal [sipDelay]="0.16" style="margin:1.5rem auto;"></div>
      <p class="tx " sipScrollReveal [sipDelay]="0.24" style="max-width:500px;margin:0 auto;">Our fighters don't just talk about adversity. They've lived it — and they show DFW students what's possible when you combine discipline, mentorship, and community.</p>
    </div>
    <div class="row g-4 align-items-stretch">
      <div class="col-lg-7 " sipScrollReveal [sipDelay]="0.32">
        <div class="fighter-card h-100">
          <div class="row align-items-center g-4">
            <div class="col-md-5 text-center">
              <div style="width:160px;height:160px;border-radius:50%;border:2px solid rgba(0,212,255,.35);margin:0 auto;box-shadow:0 0 40px rgba(0,212,255,.25);overflow:hidden;background:#040d18;">
                <img src="assetses/img/Kennedy-Nzechukwu.png" alt="Kennedy Nzechukwu UFC Fighter" style="width:100%;height:100%;object-fit:cover;object-position:top;">
              </div>
              <div class="fighter-name mt-3">Kennedy<br><span>Nzechukwu</span></div>
              <p style="font-size:.8rem;color:var(--cm);font-family:var(--fb);margin-top:.3rem;">UFC Light Heavyweight Fighter</p>
            </div>
            <div class="col-md-7">
              <p class="lbl mb-2">Why He's Involved</p>
              <p style="font-size:.92rem;color:var(--cm);line-height:1.8;font-family:var(--fb);">Kennedy understands what it means to fight through adversity — inside and outside the cage. His involvement in the DFW Anti-Bullying Movement brings credibility, inspiration, and direct mentorship to students who need it most.</p>
              <div style="margin-top:1.2rem;">
                <span class="fighter-tag">🥊 Professional UFC Fighter</span>
                <span class="fighter-tag">💪 Certified Trainer</span>
                <span class="fighter-tag">📱 100K+ Social Reach</span>
                <span class="fighter-tag">🎯 DFW Community Advocate</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 " sipScrollReveal [sipDelay]="0.32" style="transition-delay:.1s;">
        <div class="uc p-4 h-100 d-flex flex-column justify-content-center text-center">
          <p class="lbl">Platform Reach &amp; Impact</p>
          <div class="row g-3 mt-2">
            <div class="col-6">
              <div class="fighter-stat">
                <div class="n">100K+</div>
                <div class="l">Social Media Followers</div>
              </div>
            </div>
            <div class="col-6">
              <div class="fighter-stat">
                <div class="n">UFC</div>
                <div class="l">Professional Level</div>
              </div>
            </div>
            <div class="col-12">
              <div style="height:1px;background:rgba(0,212,255,.1);margin:.5rem 0;"></div>
              <p style="font-size:.85rem;color:var(--cm);font-style:italic;font-family:var(--fb);margin:1rem 0 0;">
                "When businesses partner with us, their brand appears on my platforms — reaching a highly engaged, trust-based DFW audience."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DSA Section -->
    <div class="row g-4 mt-3">
      <div class="col-12 " sipScrollReveal [sipDelay]="0.4">
        <div class="uc p-4">
          <div class="row align-items-center g-4">
            <div class="col-md-2 text-center">
              <div style="font-size:4rem;">🏫</div>
            </div>
            <div class="col-md-7">
              <p class="lbl mb-1">Primary Sponsor</p>
              <h4 style="font-family:var(--fh);font-size:2rem;letter-spacing:.05em;color:var(--cw);margin-bottom:.5rem;">Dallas Security Academy</h4>
              <p style="font-size:.9rem;color:var(--cm);line-height:1.75;font-family:var(--fb);margin:0;">DSA provides the certified instructors, structured curriculum, and facility access that makes the DFW Anti-Bullying Movement more than a program — it makes it a proven pipeline from struggle to strength.</p>
            </div>
            <div class="col-md-3 text-center">
              <span class="fighter-tag d-block mb-2">🏆 Certified Instructors</span>
              <span class="fighter-tag d-block mb-2">📍 DFW Facilities</span>
              <span class="fighter-tag d-block">📊 Structured Curriculum</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════ WHAT STUDENTS GET ════════ -->
<section class="ustudents" id="students">
  <div class="container">
    <div class="text-center mb-5">
      <p class="lbl " sipScrollReveal [sipDelay]="0">Student Programs</p>
      <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">What Every Participating<br><span class="ac">Student Receives</span></h2>
      <div class="dv " sipScrollReveal [sipDelay]="0.16" style="margin:1.5rem auto;"></div>
      <p class="tx " sipScrollReveal [sipDelay]="0.24" style="max-width:500px;margin:0 auto;">Through verified school and organization partnerships, qualified DFW students gain access to six structured programs — all at no cost to families.</p>
    </div>
    <div class="row g-4">
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0">
        <div class="uc benefit-card h-100">
          <div class="benefit-icon">💪</div>
          <h5>Strength &amp; Conditioning</h5>
          <p>Professionally designed fitness programs that build physical strength, endurance, and body confidence — creating a foundation of resilience that extends well beyond the gym.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0.08">
        <div class="uc benefit-card h-100">
          <div class="benefit-icon">🥋</div>
          <h5>Self-Defense Instruction</h5>
          <p>Certified self-defense training taught by professional instructors. Students learn situational awareness, de-escalation, and practical protection skills — building confidence, not aggression.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0.24">
        <div class="uc benefit-card h-100">
          <div class="benefit-icon">🧠</div>
          <h5>Life &amp; Behavioral Coaching</h5>
          <p>One-on-one and group coaching sessions that address emotional regulation, decision-making, conflict resolution, and goal-setting — giving students tools to navigate real-world challenges.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0">
        <div class="uc benefit-card h-100">
          <div class="benefit-icon">⭐</div>
          <h5>Confidence &amp; Discipline Development</h5>
          <p>Structured programs that transform self-doubt into self-assurance. Students develop the discipline to show up, follow through, and believe in their own ability to succeed.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0.08">
        <div class="uc benefit-card h-100">
          <div class="benefit-icon">🎯</div>
          <h5>Critical Thinking Skills</h5>
          <p>Sessions designed to sharpen analytical thinking, creative problem-solving, and independent reasoning — skills that directly impact academic performance and long-term success.</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 " sipScrollReveal [sipDelay]="0.24">
        <div class="uc benefit-card h-100">
          <div class="benefit-icon">👨‍👩‍👧</div>
          <h5>Parent Coaching &amp; Self-Defense</h5>
          <p>Because bullying affects the entire family. Parents receive coaching support, communication tools, and optional self-defense training to create a united, protective home environment.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════════ HOW TO JOIN ════════ -->
<section class="uhow" id="join">
  <div class="container">
    <div class="row g-5 align-items-center">
      <div class="col-lg-6">
        <p class="lbl " sipScrollReveal [sipDelay]="0">Get Involved</p>
        <h2 class="hd2 " sipScrollReveal [sipDelay]="0.08">How to Join the<br><span class="ac">Movement</span></h2>
        <div class="dv " sipScrollReveal [sipDelay]="0.16"></div>
        <p class="tx " sipScrollReveal [sipDelay]="0.24" style="margin-bottom:2.5rem;">Whether you're a school, parent, business, or community organization — there's a role for you in the DFW Anti-Bullying Movement.</p>

        <p class="lbl mb-2" sipScrollReveal [sipDelay]="0.32" style="color:var(--ccl);">For Schools &amp; Organizations</p>
        <div class="step-item " sipScrollReveal [sipDelay]="0.08"><div class="step-num">01</div><div><h6>Contact Us or Register Below</h6><p>Fill out the form on this page or contact our team directly. We'll verify your school or organization and connect you with a program coordinator.</p></div></div>
        <div class="step-item " sipScrollReveal [sipDelay]="0.24"><div class="step-num">02</div><div><h6>Schedule a Program Review</h6><p>We'll review your student population, needs, and location to match you with the right program structure and DSA-certified trainers.</p></div></div>
        <div class="step-item " sipScrollReveal [sipDelay]="0.32"><div class="step-num">03</div><div><h6>Launch the Program</h6><p>Students are enrolled, programs begin, and measurable outcomes are tracked and reported back to schools and parents throughout.</p></div></div>

        <p class="lbl mt-4 mb-2" sipScrollReveal [sipDelay]="0.4" style="color:var(--ccl);">For Businesses &amp; Sponsors</p>
        <div class="step-item " sipScrollReveal [sipDelay]="0.48"><div class="step-num">01</div><div><h6>Become a Youth Impact Partner</h6><p>Register your business below and select your sponsorship level. Your brand is placed at training facilities, on podcasts, and across UFC fighter platforms.</p></div></div>
        <div class="step-item " sipScrollReveal [sipDelay]="0.56"><div class="step-num">02</div><div><h6>Receive Branded Exposure</h6><p>Your business gets measurable, community-aligned visibility — reaching DFW residents who trust brands that invest in youth development.</p></div></div>
      </div>
      <div class="col-lg-6 " sipScrollReveal [sipDelay]="0.08" style="transition-delay:.15s;">
        <div class="uc p-4 mb-3" style="border-color:rgba(0,212,255,.2);">
          <p class="lbl mb-2">For Residents</p>
          <h5 style="font-family:var(--fh);font-size:1.4rem;letter-spacing:.05em;color:var(--cw);margin-bottom:.5rem;">Support Without Sponsoring</h5>
          <p style="font-size:.88rem;color:var(--cm);line-height:1.75;margin-bottom:1rem;font-family:var(--fb);">UMYOBizDFW members at just <strong style="color:var(--cc);">$2.54/month</strong> directly fund the Anti-Bullying Movement through our 20% revenue distribution model. Your membership is your contribution.</p>
          <a href="/#registration-form" class="btn-c"  style="font-size:.8rem;padding:.75rem 1.5rem;">Join as a Member</a>
        </div>
        <div class="uc p-4 mb-3">
          <p class="lbl mb-2">For Schools</p>
          <h5 style="font-family:var(--fh);font-size:1.4rem;letter-spacing:.05em;color:var(--cw);margin-bottom:.5rem;">Free Program Access</h5>
          <p style="font-size:.88rem;color:var(--cm);line-height:1.75;margin-bottom:1rem;font-family:var(--fb);">Qualified DFW schools gain access to student programs at no cost through our verified school partnership model. Register below to start the conversation.</p>
          <a href="/#registration-form" class="btn-o" style="font-size:.8rem;padding:.7rem 1.5rem;">Register Your School</a>
        </div>
        <div class="uc p-4" style="background:rgba(0,212,255,.06);border-color:rgba(0,212,255,.25);">
          <p class="lbl mb-2">For Anti-Bullying Associations</p>
          <h5 style="font-family:var(--fh);font-size:1.4rem;letter-spacing:.05em;color:var(--cw);margin-bottom:.5rem;">Receive 20% Revenue Share</h5>
          <p style="font-size:.88rem;color:var(--cm);line-height:1.75;margin-bottom:1rem;font-family:var(--fb);">Participating anti-bullying associations receive 20% of UMYOBizDFW revenue — a sustainable, long-term funding model that grows as the community grows.</p>
          <a href="/#partner" class="btn-c" style="font-size:.8rem;padding:.75rem 1.5rem;">Partner With Us</a>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- ════════ FINAL CTA ════════ -->
<section class="ucta">
  <div class="uctag"></div>
  
  <div class="container" style="position:relative;z-index:1;">
    <p class="lbl " sipScrollReveal [sipDelay]="0">Together We Rise</p>
    <h2 class="" sipScrollReveal [sipDelay]="0.08">Bullying Loses Power<br><span>When Community Unites</span></h2>
    <p class="" sipScrollReveal [sipDelay]="0.16" style="font-style:italic;color:var(--cm);font-size:1.05rem;max-width:500px;margin:2rem auto;font-family:var(--fb);line-height:2;">
      <strong style="color:var(--cw);">When students are protected,</strong> families stabilize.<br>
      <strong style="color:var(--cw);">When families stabilize,</strong> communities thrive.<br>
      <strong style="color:var(--cw);">When DFW stands together,</strong> nothing can hold us back.
    </p>
    <div class="d-flex flex-wrap gap-3 justify-content-center " sipScrollReveal [sipDelay]="0.24">
      <a href="/#registration-form" class="btn-c" style="font-size:1rem;padding:1.1rem 2.8rem;">👉 Register Now</a>
      <a href="/#partner" class="btn-o" style="font-size:1rem;padding:1.1rem 2.2rem;" target="_blank">Join UMYOBizDFW</a>
    </div>
  </div>
</section>

<!-- ════════ FOOTER ════════ -->
<footer class="ufoot">
  <div class="container">
    <img src="assetses/img/logo.png" alt="UMYOBizDFW" onerror="this.style.display='none'">
    <div class="ufb">UMYOBizDFW</div>
    <p>DFW's First Privacy-Gated Digital Community</p>
    <div class="d-flex justify-content-center gap-4 flex-wrap">
      <a href="/">Home</a>
      <a href="/about">About Us</a>
      <a routerLink="/networks">Network</a>
      <a routerLink="/hub">Hub</a>
      <a routerLink="/anti-bullying">Anti-Bullying</a>
      <a routerLink="/community-impact">Community Fund</a>
      <a routerLink="/empower-youth">Empower Youth</a>
      <a routerLink="/services">Type of Servcies</a>
      <a routerLink="/cf">Card Features</a>
      <a href="/terms">Terms &amp; Conditions</a>
    </div>
    <p class="ufc2">© 2025 UMYOBizDFW · Built by the community, for the community</p>
  </div>
</footer>